import { addSchemaField } from '@package/config/Blocks/schemas/utils';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  bg_color: {
    id: 'bgColor',
    defaultMessage: 'Colore di sfondo del blocco',
  },
  item_bg_color: {
    id: 'ItemBgColor',
    defaultMessage: "Colore di sfondo dell'elemento",
  },
  title_color: {
    id: 'TitleColor',
    defaultMessage: 'Colore del titolo',
  },
  text_color: {
    id: 'TextColor',
    defaultMessage: 'Colore del testo',
  },
  button_color: {
    id: 'ButtonColor',
    defaultMessage: 'Colore del bottone',
  },
  bgFullWidth: {
    id: 'bgFullWidth',
    defaultMessage: 'Imposta lo sfondo a larghezza intera',
  },
});

export const ITEM_BG_COLORS = [
  { name: 'blue', label: 'Blu' },
  { name: 'grey', label: 'Grigio' },
  { name: 'light-grey', label: 'Grigio chiaro' },
  { name: 'white', label: 'Bianco' },
  { name: 'transparent', label: 'Trasparente' },
];

export const BG_COLORS = [
  { name: 'outline-white', label: 'Trasparent' },
  { name: 'light-grey', label: 'Grigio chiaro' },
  { name: 'blue', label: 'Blu' },
];

export const TITLE_COLORS = [
  { name: 'blue', label: 'Blu' },
  { name: 'grey', label: 'Grigio' },
  { name: 'white', label: 'Bianco' },
];

export const TEXT_COLORS = [
  { name: 'blue', label: 'Blu' },
  { name: 'grey', label: 'Grigio' },
  { name: 'white', label: 'Bianco' },
];

export const BUTTON_COLORS = [
  { name: 'blue', label: 'Blu' },
  { name: 'white', label: 'Bianco' },
  { name: 'outline-blue', label: 'Trasparente blu' },
  { name: 'outline-white', label: 'Trasparente bianco' },
];

export const addPresetFields = (schema, intl, pos, fieldset, fields) => {
  // Il campo fields va usato in questo modo. Se vuoto mette tutti i campi coi suoi default.
  // fields={
  //   item_bg_color: {
  //     colors:['white','blue'],
  //     default:'blue',
  //   },
  //   title_color: {}, // se non vengono passati i colori, vengono mostrate tutte le opzioni possibili
  //   text_color: {},
  //   button_color: {},
  // }
  const fieldNames = fields
    ? Object.keys(fields)
    : ['item_bg_color', 'title_color', 'text_color', 'button_color'];

  if (fieldNames.indexOf('bg_color') >= 0) {
    const fieldConfig = fields?.['bg_color'];

    let colors = BG_COLORS.filter((c) =>
      fieldConfig?.colors?.length > 0
        ? fieldConfig.colors.indexOf(c.name) >= 0
        : true,
    );

    addSchemaField(
      schema,
      'bg_color',
      intl.formatMessage(messages.bg_color),
      null,
      {
        widget: 'color_list',
        intl: intl,
        colors: colors,
        defaultValue: fieldConfig?.default ?? colors[0].name,
      },
      pos,
      fieldset,
    );
    pos++;

    addSchemaField(
      schema,
      'fullWidth',
      intl.formatMessage(messages.bgFullWidth),
      null,
      { type: 'boolean', default: false },
      pos,
      fieldset,
    );
    pos++;
  }

  if (fieldNames.indexOf('item_bg_color') >= 0) {
    const fieldConfig = fields?.['item_bg_color'];

    let colors = ITEM_BG_COLORS.filter((c) =>
      fieldConfig?.colors?.length > 0
        ? fieldConfig.colors.indexOf(c.name) >= 0
        : true,
    );

    addSchemaField(
      schema,
      'item_bg_color',
      intl.formatMessage(messages.item_bg_color),
      null,
      {
        widget: 'color_list',
        intl: intl,
        colors: colors,
        defaultValue: fieldConfig?.default ?? colors[0].name,
      },
      pos,
      fieldset,
    );
    pos++;
  }

  if (fieldNames.indexOf('title_color') >= 0) {
    const fieldConfig = fields?.['title_color'];
    let colors = TITLE_COLORS.filter((c) =>
      fieldConfig?.colors?.length > 0
        ? fieldConfig.colors.indexOf(c.name) >= 0
        : true,
    );
    addSchemaField(
      schema,
      'title_color',
      intl.formatMessage(messages.title_color),
      null,
      {
        widget: 'color_list',
        intl: intl,
        colors: colors,
        defaultValue: fieldConfig?.default ?? colors[0].name,
      },
      pos,
      fieldset,
    );
    pos++;
  }

  if (fieldNames.indexOf('text_color') >= 0) {
    const fieldConfig = fields?.['text_color'];
    let colors = TEXT_COLORS.filter((c) =>
      fieldConfig?.colors?.length > 0
        ? fieldConfig?.colors.indexOf(c.name) >= 0
        : true,
    );
    addSchemaField(
      schema,
      'text_color',
      intl.formatMessage(messages.text_color),
      null,
      {
        widget: 'color_list',
        intl: intl,
        colors: colors,
        defaultValue: fieldConfig?.default ?? colors[0].name,
      },
      pos,
      fieldset,
    );
    pos++;
  }

  if (fieldNames.indexOf('button_color') >= 0) {
    const fieldConfig = fields?.['button_color'];
    let colors = BUTTON_COLORS.filter((c) =>
      fieldConfig?.colors?.length > 0
        ? fieldConfig.colors.indexOf(c.name) >= 0
        : true,
    );

    addSchemaField(
      schema,
      'button_color',
      intl.formatMessage(messages.button_color),
      null,
      {
        widget: 'color_list',
        intl: intl,
        colors: colors,
        defaultValue: fieldConfig?.default ?? colors[0].name,
      },
      pos,
      fieldset,
    );
    pos++;
  }
  return pos;
};

export const getPresetClasses = ({
  bg_color,
  item_bg_color,
  title_color,
  text_color,
  button_color,
  djsButtonsAlignCenter,
  fullWidth = false,
  className = '',
  usePresetDefaults = true,
  header_align,
}) => {
  let defaults = {
    item_bg_color: 'white',
    title_color: 'grey',
    text_color: 'grey',
    button_color: 'outline-blue',
  };

  let values = {
    'rw--preset-bg-':
      bg_color ?? (usePresetDefaults ? defaults.bg_color : null),
    'rw--preset-item-': item_bg_color ?? (usePresetDefaults ? 'white' : null),
    'rw--preset-title-': title_color ?? (usePresetDefaults ? 'grey' : null),
    'rw--preset-header-align-': header_align,
    'rw--preset-text-': text_color ?? (usePresetDefaults ? 'grey' : null),
    'rw--preset-button-':
      button_color ?? (usePresetDefaults ? 'outline-blue' : null),
    'rw--preset-draftjs-buttons-align-': djsButtonsAlignCenter
      ? 'center'
      : null,
  };

  let classes = [className, 'rw--preset-wrapper'];

  Object.keys(values).forEach((k) => {
    if (values[k]) {
      classes.push(k + values[k]);
    }
  });

  if (fullWidth) {
    classes.push('full-width');
  }

  return classes.join(' ');
};
